module.exports = __webpack_public_path__ + "img/canbadge-round-32mm-momo_line.028a0ed5.png";